import type { SafeAny } from '@/common/types';
import { axiosInstance } from '@/common/utils';

export enum NotificationTypes {
  Success = 'success',
  Warning = 'warning',
  Error = 'danger'
}

export const getStudiesId = async ({ rootState, state, commit }: SafeAny) => {
  const url = `${rootState.env?.requestUrl.signals}/studies/`;

  state.ids.isLoading = true;
  state.ids.error = undefined;

  try {
    const response = await axiosInstance.get(url);

    state.ids.isLoading = false;
    state.ids.data = response.data;
  } catch (error: SafeAny) {
    state.ids.isLoading = false;
    state.ids.data = [];

    commit(
      'addNotification',
      {
        i18nTitle: 'errorGetStudies',
        type: NotificationTypes.Error,
        i18nDescription: error.message
      },
      { root: true }
    );
  }
};
